export const badgeStyles = {
  base: 'inline-flex items-center rounded px-2 py-0.5 font-sans text-2xs font-semibold uppercase tracking-wide sm:text-xs',
  variant: {
    brand: 'bg-brand-400/20 text-brand-950',
    neutral: 'bg-brand-100 text-brand-700',
    success: 'bg-green-100 text-green-800',
    danger: 'bg-red-100 text-red-800',
    warning: 'bg-amber-100 text-amber-900',
  },
} as const;
